import { Button } from 'primereact/button'
import { OverlayPanel } from 'primereact/overlaypanel'
import { confirmDialog } from 'primereact/confirmdialog'
import React, { useContext } from 'react'
import { useRef } from 'react'
import { useState } from 'react'
import { Toast } from 'primereact/toast'

import AgGrid from '../../../../../../Base/Components/Tables/AgGrid/AgGrid'
import { AuthContext } from '../../../../../../Base/Context/AuthContext/AuthContext'
import Loader from '../../../../../../Base/Components/Loader/Loader'
import { ConfigContext } from '../../../../../../Base/Context/ConfigContext/ConfigContext'
import { getDateTimeStringSQL } from '../../../../../../Base/Services/Moment/Luxon'
import { toastShow } from '../../../../../../Base/Services/ToastService'
import { useForm } from '../../../../../../Base/Hooks/useForm'

import { getLiquidacionDetalle, postActualizarMontoAplicadoDetalles, postEstadoLiquidacionesDetalles } from '../../../../../../API/Suministros/Liquidaciones/LiquidacionesRequest'

const OverlayLiquidacionesDetalles = ({ informacion, close, AsignarLiquidacion, habilitar }) => {
    const dl = useRef(null)
    const toast = useRef(null)
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState([])
    const [data, setData] = useState([])
    const [dialogCuenta, setDialogCuenta] = useState(false)
    const [Id, setId] = useState(null);
    
    const initialValues = {
        IdCurrency: 1,
        MontoFleteD: 0,
        MontoDesaduanajeD: 0,
        MontoEmbalajeD: 0,
        MontoOtrosCostosD: 0,

        MontoFleteL: 0,
        MontoDesaduanajeL: 0,
        MontoEmbalajeL: 0,
        MontoOtrosCostosL: 0
    }

    const { values, setValues, handleChange, handleInputChange, resetForm } = useForm(initialValues)

    const { userAuth } = useContext(AuthContext);
    const { config } = useContext(ConfigContext);

    const obtenerInformacion = async () => {
        setLoading(true)

        if (informacion) {
            const result = await getLiquidacionDetalle(informacion?.IdIngreso)
            setData(result)

        }
        setLoading(false)
    }

    const openCXP = (Id) => {
        setId(Id)
        setDialogCuenta(true)
    }

    const Botones = (rowData) =>{
        let rows =  selected.length === 0 ? [rowData] : selected
        return(
            <Button  className= 'p-button-danger' icon='pi pi-times' text onClick={(e)=> RemoverDetalle(e,rows )}/>
        )
    }

    const columnas = [
        {
            field: 'IdLiquidacionDetalle',
            header: 'ID',
            headerEn: 'ID',
            className: 'Xsmall',
            hidden: userAuth.IdRol === 1
        },
        {
            field: 'IdIngresoDetalle',
            header: 'Id Det Ingreso',
            headerEn: 'Id Det Ingreso',
            className: 'Xsmall',
            hidden: userAuth.IdRol === 1
        },
        {
            field: 'FechaCreada',
            header: 'Fecha Creado',
            headerEn: 'Create Date',
            className: 'Xsmall',
            Format: 'Date',
        },
        {
            field: 'NumeroLiquidacion',
            header: 'Número Liquidación',
            headerEn: 'Settlement Number',
            className: 'small',
            Format: 'Center'
        },
        {
            field: 'NumeroIngreso',
            header: 'No. Ingreso',
            headerEn: 'No. Income',
            className: 'Xsmall',
            Format: 'Center',
            onCellDoubleClicked: ({ data }) => {
                if (data?.IdEncabezado) {
                    openCXP(data?.IdEncabezado)
                }
            },
            Sumary: 'count',

        },
        {
            field: 'CategoriaLiquidacion',
            header: 'Categoria',
            headerEn: 'Category',
            className: 'Xsmall',
        },
        {
            field: 'MontoL',
            header: 'Monto L',
            headerEn: 'Amount L',
            className: 'Xsmall',
            Format: 'Currency',
            Sumary: 'sum'
        },
        {
            field: 'MontoD',
            header: 'Monto D',
            headerEn: 'Amount $',
            className: 'Xsmall',
            Format: 'Currency',
            Sumary: 'sum'
        },
        {
            field: 'UserName',
            header: 'Usuario Creo',
            headerEn: 'Create User',
            className: 'small',
        },
        { 
          field: 'IdLiquidacionDetalle',
          header: '',
          headerEn: '',
          className: 'Xsmall',
          Format: 'Template',
          Frozen:true,
          alignFrozen:'right',
          body: (rowData) => rowData.IdLiquidacionDetalle ? Botones(rowData) : null,
        },
    ]

    const table = {
        Data: data,
        selected: selected,
        setSelected: setSelected,
        Columns: columnas,
    }

    const RemoverDetalle = (e,rows) => {

        if (rows.length > 0) {
            let message = <div>¿Desea guardar remover el detalle de liquidación?</div>
            confirmDialog({
                message: message,
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                accept: async () => {
                    let datosDetallesCXP = rows.map((r) => {
                        return {
                            IdIngresoDetalle: r.IdIngresoDetalle,
                            MontoAplicadoL: r.MontoL,
                            MontoAplicadoD: r.MontoD,
                            IdUserEdit: userAuth.IdUser,
                            FechaEdit: getDateTimeStringSQL(new Date())
                        }
                    });


                    let dataDetallesL = rows.map((ld) => {
                        return {
                            ...ld,
                            IdStatus: 6,
                            IdUserEdit: userAuth.IdUser,
                            FechaEdit: getDateTimeStringSQL(new Date())
                        }
                    })
                    
                    const resultLD = await postEstadoLiquidacionesDetalles(dataDetallesL)

                    if (resultLD?.length > 0) {
                        if (resultLD[0]?.ERROR === 0) {
                            const resultCXPD = await postActualizarMontoAplicadoDetalles(datosDetallesCXP)
                            if (resultCXPD?.length > 0) {
                                if (resultLD[0]?.ERROR === 0) {
                                    ActualizarInformacionIngreso(e,dataDetallesL)
                                }
                            } else {
                                toastShow(toast, 'error', 'Error', 'Ocurrio un error al actualizar el balance del detalle de CXP')
                            }
                        } else {
                            toastShow(toast, 'error', 'Error', resultLD[0]?.MSJ)
                        }
                    } else {
                        toastShow(toast, 'error', 'Error', 'Ocurrio un error')
                    }
                    obtenerInformacion()
                },
                reject: () => { setSelected([])}
            })
        }
    }

    const ActualizarInformacionIngreso = (e, datosActualizar) => {
        if (datosActualizar?.length > 0) {
            let valoresDesaduanajeD = (datosActualizar?.filter((d) => d.IdCategoriaLiquidacion === 1).reduce((t, v) => t + v.CostoD, 0))
            let valoresFleteD = (datosActualizar?.filter((d) => d.IdCategoriaLiquidacion === 2).reduce((t, v) => t + v.CostoD, 0))
            let valoresEmbalajeD = (datosActualizar?.filter((d) => d.IdCategoriaLiquidacion === 3).reduce((t, v) => t + v.CostoD, 0))
            let valoresOtrosCostosD = (datosActualizar?.filter((d) => d.IdCategoriaLiquidacion === 4).reduce((t, v) => t + v.CostoD, 0))

            let valoresDesaduanajeL = (datosActualizar?.filter((d) => d.IdCategoriaLiquidacion === 1).reduce((t, v) => t + v.CostoL, 0))
            let valoresFleteL = (datosActualizar?.filter((d) => d.IdCategoriaLiquidacion === 2).reduce((t, v) => t + v.CostoL, 0))
            let valoresEmbalajeL = (datosActualizar?.filter((d) => d.IdCategoriaLiquidacion === 3).reduce((t, v) => t + v.CostoL, 0))
            let valoresOtrosCostosL = (datosActualizar?.filter((d) => d.IdCategoriaLiquidacion === 4).reduce((t, v) => t + v.CostoL, 0))

            let tempoValues = { ...values }
            tempoValues.MontoEmbalajeD = valoresEmbalajeD
            tempoValues.MontoFleteD = valoresFleteD
            tempoValues.MontoDesaduanajeD = valoresDesaduanajeD
            tempoValues.MontoOtrosCostosD = valoresOtrosCostosD

            tempoValues.MontoEmbalajeL = valoresEmbalajeL
            tempoValues.MontoFleteL = valoresFleteL
            tempoValues.MontoDesaduanajeL = valoresDesaduanajeL
            tempoValues.MontoOtrosCostosL = valoresOtrosCostosL


            setValues(tempoValues)
            AsignarLiquidacion(e, tempoValues, dl, 2)
            setSelected([])
        }
    }

    const openOver = (e) => {
        dl.current.toggle(e)
        obtenerInformacion()
    }
    return (
        <div>
            <Button icon='ri-newspaper-line' className='mt-2' onClick={(e) => openOver(e)} tooltip='Detalle Liquidación' disabled={!habilitar}/>
            <OverlayPanel ref={dl} showCloseIcon dismissable={false} onHide={close} style={{ width: '45vw', height: '45vh' }} >
                <Toast ref={toast}/>
                <Loader loading={loading} querySelector={'#DetallesCXPLiquidacion'} />
                <div className='d-flex gap' style={{ alignItems: 'center' }}>
                    <h5>Detalles Liquidación</h5>
                    <Button icon='pi pi-refresh' onClick={() => obtenerInformacion()} rounded text loading={loading} />
                </div>
                <div className='pt-1' style={{ height: '37vh' }} id='DetallesCXPLiquidacion'>
                    <AgGrid table={table} />
                </div>

                {/* <ModalCuentasPorPagar
                    dialogCuentas={dialogCuenta}
                    hideDialog={hideDialog}
                    IdFactura={Id}
                /> */}
            </OverlayPanel>
        </div>
    )
}

export default OverlayLiquidacionesDetalles
